export const copyToClipboard = (value: string): boolean => {
    if (navigator) {
        navigator.clipboard.writeText(value);
        return true;
    }
    return false;
};
